import quoteEvergreenBgMobile from "app/assets/quote_patterns/quote-evergreen-bg-mobile.png"
import quoteGeometricBgMobile from "app/assets/quote_patterns/quote-geometric-bg-mobile.png"
import quoteLeavesBgMobile from "app/assets/quote_patterns/quote-leaves-bg-mobile.png"
import quoteOceanBgMobile from "app/assets/quote_patterns/quote-ocean-bg-mobile.png"
import quoteWaveBgMobile from "app/assets/quote_patterns/quote-wave-bg-mobile.png"
import React from "react"
import { twMerge } from "tailwind-merge"

import { DEFAULT_HIGHLIGHT_CLASSES } from "../WebsiteBuilderV2Page"

import { ScrollReveal } from "./shared/ScrollReveal"

// Relative luminance (0–1). Use dark text when background luminance > threshold for readability.
const hexLuminance = (hex) => {
  const h = hex.replace(/^#/, "")
  const r = parseInt(h.slice(0, 2), 16) / 255
  const g = parseInt(h.slice(2, 4), 16) / 255
  const b = parseInt(h.slice(4, 6), 16) / 255
  return 0.299 * r + 0.587 * g + 0.114 * b
}

const QuoteSectionMobile = ({ section, theme, highlightedField }) => {
  const isHighlighted = highlightedField === `section-${section.id}`
  const settings = section.settings || {}

  // Quote settings
  const quoteAuthor = settings.quoteAuthor || ""
  const rawPattern = (settings.backgroundPattern || "leaves").toLowerCase()
  const legacyToNew = { water: "ocean", pine: "evergreen", swoop: "wave" }
  const backgroundPattern = (legacyToNew[rawPattern] || rawPattern).toLowerCase()

  const palette = {
    textLight: theme?.colors?.textLight || "#FFFFFF",
    textDark: theme?.colors?.textDark || "#0b3954",
    primaryDark: theme?.colors?.primaryDark || "#8B6F6B",
    secondary: theme?.colors?.secondary || "#e9dfdc",
    bgDark: theme?.colors?.bgDark || "#efeae8"
  }

  // Use dark text when background is light so quote remains readable (V2 migration quote colors fix)
  const bgLuminance = hexLuminance(palette.bgDark)
  const quoteTextColor = bgLuminance > 0.55 ? palette.textDark : palette.textLight

  // Get background pattern styles
  const getBackgroundPattern = () => {
    switch (backgroundPattern) {
      case "leaves":
        return { backgroundColor: palette.bgDark }
      case "ocean":
        return { backgroundColor: palette.bgDark }
      case "evergreen":
        return { backgroundColor: palette.bgDark }
      case "wave":
        return { backgroundColor: palette.bgDark }
      case "geometric":
        return { backgroundColor: palette.bgDark }
      default:
        return { backgroundColor: palette.bgDark }
    }
  }

  // Get background image for each pattern
  const getBackgroundImage = () => {
    switch (backgroundPattern) {
      case "leaves":
        return quoteLeavesBgMobile
      case "ocean":
        return quoteOceanBgMobile
      case "evergreen":
        return quoteEvergreenBgMobile
      case "wave":
        return quoteWaveBgMobile
      case "geometric":
        return quoteGeometricBgMobile
      default:
        return quoteLeavesBgMobile
    }
  }

  return (
    <section
      className={twMerge("relative overflow-hidden py-8 md:py-12", isHighlighted ? DEFAULT_HIGHLIGHT_CLASSES : "")}
      style={{
        ...getBackgroundPattern(),
        width: "100%"
      }}>
      {/* Background image from Figma design - preserving original transparencies */}
      <img
        src={getBackgroundImage()}
        alt=""
        aria-hidden
        className="cover pointer-events-none absolute inset-0 size-full select-none bg-cover"
      />

      <ScrollReveal variant="fadeUp" className="relative z-10 mx-auto max-w-6xl px-5 md:px-4">
        <div className="flex min-h-[220px] items-center justify-center py-4 text-center">
          <div className="max-w-4xl">
            {/* Quote Text */}
            <blockquote
              className="mb-4 text-[20px] leading-[28px]"
              style={{
                fontFamily: theme?.fonts?.heading || "serif",
                fontWeight: "500",
                color: quoteTextColor,
                wordBreak: "normal",
                overflowWrap: "normal",
                hyphens: "none"
              }}>
              &quot;{section.body || "Your quote text will appear here..."}&quot;
            </blockquote>

            {/* Quote Author */}
            {quoteAuthor && (
              <div
                className="text-[16px] leading-[22px]"
                style={{
                  fontFamily: theme?.fonts?.paragraph || "sans-serif",
                  fontWeight: theme?.fonts?.paragraphBoldWeight || "600",
                  color: quoteTextColor
                }}>
                — {quoteAuthor}
              </div>
            )}
          </div>
        </div>
      </ScrollReveal>
    </section>
  )
}

export default QuoteSectionMobile
